// Dynamic Experiments
export const CARDFINDER_THINKING_INTERSTITIAL_ID = 'card_6668_cardfinder_thinking_interstitial';
